import React, { useState, useEffect } from 'react';
import LeftColumn from '../LeftColumn/LeftColumn';
import DashboardHome from '../DashboardPages/Home/DashboardHome';
import DashboardFeedback from '../DashboardPages/Feedback/DashboardFeedback';
import DashboardUsers from '../DashboardPages/Users/DashboardUsers';
import DashboardProjects from '../DashboardPages/Projects/DashboardProjects';
import DashboardAI from '../DashboardPages/AI/DashboardAI';
import './dashboardcontent.css';

export default function DashboardContent() {
    const [activeSection, setActiveSection] = useState('home'); 
    const [dashboardData, setDashboardData] = useState(null); 

    // Fetch data from the API
    useEffect(() => {
        const fetchData = async () => {
            try {
                // console.log(process.env.REACT_APP_DASHBOARD_URL)
                const response = await fetch(`${process.env.REACT_APP_DASHBOARD_URL}/get_data`);
                console.log(response);
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }

                // let data = await response.json();
                // setDashboardData(data);

                let data = await response.text();
                data = data.replace(/\bNaN\b/g, 'null')
                const jsonData = JSON.parse(data);

                setDashboardData(jsonData);
                
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchData();
    }, []); 

    const renderContent = () => {
        switch (activeSection) {
            case 'home':
                return <DashboardHome data={dashboardData?.home} />;
            case 'projects':
                return <DashboardProjects data={dashboardData?.projects} />;
            case 'users':
                return <DashboardUsers data={dashboardData?.users} />;
            case 'feedback':
                return <DashboardFeedback data={dashboardData?.feedback} />;
            case 'AI':
                return <DashboardAI/>;
            default:
                return null;
        }
    };

    return (
        <div className='wrapper'>
            <LeftColumn setActiveSection={setActiveSection} activeSection={activeSection}/>
            <div className='chartsContainer'>
               {renderContent()}
            </div>
        </div>
      );
}